import Congratulation from "../../components/Congratulation/Congratulation";
import Header from "../../components/Header/Header";
import HomeCards from "../../components/HomeCards/HomeCards";
import HomeCategory from "../../components/HomeCategory/HomeCategory";
import HomeDesc from "../../components/HomeDesc/HomeDesc";
import Layout from "../../components/Layout/Layout";
import Line from "../../components/Line/Line";
import { useHomeData } from "../../hooks/api/useHomeData";
import { Helmet } from 'react-helmet-async';

import "./Home.css";

const HomeLoader = () => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    gap: "16px",
    background: "#fff",
  }}>
    <svg
      width="48" height="48" viewBox="0 0 48 48"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ animation: "spin 1s linear infinite" }}
    >
      <circle cx="24" cy="24" r="20"
        stroke="#efefef" strokeWidth="4"/>
      <path d="M44 24c0-11.046-8.954-20-20-20"
        stroke="#d90429" strokeWidth="4" strokeLinecap="round"/>
    </svg>
    <p style={{
      fontFamily: "Montserrat Alternates, sans-serif",
      fontSize: "0.9rem",
      color: "#999",
      letterSpacing: "0.04em",
    }}>
      Завантаження...
    </p>
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const HomeError = ({ message, onRetry }: { message: string; onRetry: () => void }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    gap: "16px",
    padding: "20px",
    background: "#fff",
  }}>
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="#d90429" strokeWidth="1.5"/>
      <path d="M12 7v6M12 16.5v.5" stroke="#d90429"
        strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
    <p style={{
      fontFamily: "Montserrat Alternates, sans-serif",
      fontSize: "1rem",
      fontWeight: 600,
      color: "#1a1a1a",
    }}>
      Помилка завантаження
    </p>
    <p style={{
      fontFamily: "Montserrat Alternates, sans-serif",
      fontSize: "0.85rem",
      color: "#999",
      textAlign: "center",
      maxWidth: "300px",
    }}>
      {message}
    </p>
    <button
      onClick={onRetry}
      style={{
        background: "#d90429",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "12px 28px",
        fontFamily: "Montserrat Alternates, sans-serif",
        fontSize: "0.9rem",
        fontWeight: 600,
        cursor: "pointer",
        marginTop: "8px",
      }}
    >
      Спробувати знову
    </button>
  </div>
);

const Home = () => {
  const { data, isLoading, error } = useHomeData();

  if (error) {
    return (
      <HomeError
        message={error.message}
        onRetry={() => window.location.reload()}
      />
    );
  }

  if (isLoading || !data?.data) {
    return <HomeLoader />;
  }

  const attr = data.data.attributes;

  if (!attr) {
    return (
      <HomeError
        message="Дані не знайдено. Перевірте статус публікації в Strapi."
        onRetry={() => window.location.reload()}
      />
    );
  }

  return (
    <Layout className="home">
      <Helmet>
  <title>Lovely Layers — Одяг та взуття</title>
  <meta name="description"
    content="Інтернет-магазин одягу та взуття. Кросівки, футболки, шорти від топових брендів Jordan, Nike, Adidas, Puma." />
  <meta name="keywords"
    content="купити кросівки, одяг онлайн, Jordan, Nike, Adidas, Puma, взуття Україна" />
  <meta property="og:title" content="Lovely Layers" />
  <meta property="og:description"
    content="Інтернет-магазин одягу та взуття в Україні" />
  <meta property="og:type" content="website" />
  <link rel="canonical" href="https://твійдомен.ua/" />
</Helmet>
      <Header
        productsDiscountButton={attr.products_discount_button}
        isLoading={isLoading}
        products={attr.products_discount?.data || []}
      />
      <div className="container">
        <HomeCategory
          isLoading={isLoading}
          productNewLink={attr.product_new_link?.data?.attributes}
          productNewLinkText={attr.product_new_link_text}
          title={attr.product_new_title}
          products={attr.product_new?.data || []}
        />
        <Line />
        {attr.congratulation && (
          <>
            <Congratulation congratulation={attr.congratulation} />
            <Line />
          </>
        )}
        <HomeDesc homeDescs={attr.home_descs?.data || []} />
        <Line />
        <HomeCards cards={attr.cards || []} />
      </div>
    </Layout>
  );
};

export default Home;
